// Roles & access — the created roles from GET /roles, split into system
// (isDefault) and custom sections. Also warms the GET /modules cache so opening
// a role's matrix is instant.

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from '@/components/common';
import { useGetModulesQuery, useGetRolesQuery } from '@/api/endpoints/rolesApi';
import useModuleAccess from '@/hooks/useModuleAccess';
import RoleRow from './RoleRow';

const RolesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { canCreate } = useModuleAccess('roles');
  const { data: roles = [], isLoading, isError } = useGetRolesQuery();
  useGetModulesQuery(); // prefetch the capability matrix

  const systemRoles = roles.filter((r) => r.isDefault);
  const customRoles = roles.filter((r) => !r.isDefault);

  return (
    <div className='roles-page'>
      <header className='roles-page__header'>
        <div className='roles-page__heading'>
          <h1 className='roles-page__title'>{t('roles_title')}</h1>
          <p className='roles-page__subtitle'>{t('roles_subtitle')}</p>
        </div>
        {canCreate && (
          <Button iconStart='plus' onClick={() => navigate('/roles/new')}>
            {t('roles_new_custom')}
          </Button>
        )}
      </header>

      {isLoading && <p className='roles-page__subtitle'>{t('text_loading')}</p>}
      {isError && <p className='roles-page__subtitle'>{t('error_generic')}</p>}

      {!isLoading && !isError && (
        <>
          {systemRoles.length > 0 && (
            <section className='roles-page__section'>
              <h2 className='roles-page__section-label'>{t('roles_section_system')}</h2>
              <Card padded={false} className='roles-page__list'>
                {systemRoles.map((role) => (
                  <RoleRow key={role.id} role={role} />
                ))}
              </Card>
            </section>
          )}

          {customRoles.length > 0 && (
            <section className='roles-page__section'>
              <h2 className='roles-page__section-label'>{t('roles_section_custom')}</h2>
              <Card padded={false} className='roles-page__list'>
                {customRoles.map((role) => (
                  <RoleRow key={role.id} role={role} />
                ))}
              </Card>
            </section>
          )}
        </>
      )}
    </div>
  );
};

export default RolesPage;
